import {Navigate,  useLocation} from "react-router-dom";

const ProtectedRoute = ({children}) => {
    const location = useLocation();
    let  token = localStorage.getItem("token");


    if ((location.pathname !== '/' || location.pathname !== '/otp') &&!token  ) {

        return <Navigate to="/" />;

    }



    return children;

}
export default ProtectedRoute;